import { render, staticRenderFns } from "./JobDescription.vue?vue&type=template&id=37d2db31&scoped=true"
import script from "./JobDescription.vue?vue&type=script&lang=js"
export * from "./JobDescription.vue?vue&type=script&lang=js"
import style0 from "./JobDescription.vue?vue&type=style&index=0&id=37d2db31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2db31",
  null
  
)

export default component.exports